// https://www.keene.edu/campus/maps/tool/
import values from 'lodash/values';
import { booleanPointInPolygon, point, polygon as tpolygon, distance } from '@turf/turf';
import api from '../../Services/Api';

export const MORMAL_ZONES = {
  start: {
    polygon: [
      [
        [50.3541412, 3.5755949],
        [50.2784595, 3.4850776],
        [50.188646, 3.4631229],
        [50.0819917, 3.4889954],
        [50.0018449, 3.6749252],
        [50.0322661, 3.8550953],
        [50.1167566, 3.9295753],
        [50.2612161, 4.0199049],
        [50.3440671, 4.0045971],
        [50.3667078, 3.8910682],
        [50.3889084, 3.7671003],
        [50.3701123, 3.7215482],
        [50.3460903, 3.7046561],
        [50.3946164, 3.673428],
        [50.3780258, 3.6086468],
        [50.3541412, 3.5755949],
      ],
    ],
    bbox: [3.418559, 49.947365, 4.025604, 50.431319],
    proximity: [3.700433, 50.219909],
  },
  end: {
    polygon: [
      [
        [51.0757445, 2.3525333],
        [50.981452, 1.8505526],
        [50.8994603, 1.5264988],
        [50.6731281, 1.5205336],
        [50.2351557, 1.4700651],
        [49.9455588, 1.0266209],
        [49.864657, 0.6475496],
        [49.7699013, 0.2645302],
        [49.6320619, 0.1200771],
        [49.4884094, 0.0360918],
        [49.4895385, 0.0589228],
        [49.4793483, 0.0391495],
        [49.337875, 0.1284885],
        [49.1315207, 0.2354336],
        [48.8378595, 0.4823685],
        [48.4763354, 0.9407043],
        [47.9291685, 1.9686556],
        [47.8, 3.57],
        [47.9308938, 4.0253735],
        [48.1517145, 4.566493],
        [48.69, 6.18],
        [48.7897325, 6.5222311],
        [48.9450814, 6.8806601],
        [49.23, 7.0],
        [49.8991128, 6.2055802],
        [51.23, 6.78],
        [51.44, 5.48],
        [51.448832, 4.9554777],
        [51.3835399, 4.4098306],
        [51.2814744, 3.747046],
        [51.236389, 3.2316756],
        [51.22, 2.92],
        [51.0757445, 2.3525333],
      ],
    ],
    bbox: [0.036092, 47.8, 7.0, 51.448832],
    proximity: [3.4072877646376503, 50.53819085560808],
  },
};

export const TURF_POLYGON = [
  [
    [50.3541412, 3.5755949],
    [50.2784595, 3.4850776],
    [50.188646, 3.4631229],
    [50.0819917, 3.4889954],
    [50.0018449, 3.6749252],
    [50.0322661, 3.8550953],
    [50.1167566, 3.9295753],
    [50.2612161, 4.0199049],
    [50.3440671, 4.0045971],
    [50.3667078, 3.8910682],
    [50.3889084, 3.7671003],
    [50.3701123, 3.7215482],
    [50.3460903, 3.7046561],
    [50.3946164, 3.673428],
    [50.3780258, 3.6086468],
    [50.3541412, 3.5755949],
  ],
];

export const DEPARTMENT_CODES = {
  Nord: 59,
};

export const zoneToPolygon = city => {
  if (!city || !city.zone) return [];
  let polygons = city.zone
    .replace(/POLYGON \(\(/, '')
    .replace(/\)\)$/, '')
    .split(', ');
  polygons = polygons.map(polygon => {
    const coordinates = polygon.split(' ');
    return [coordinates[1], coordinates[0]].map(latLng => parseFloat(latLng, 10));
  });
  return polygons;
};

export const askTransport = (
  addressFrom,
  addressTo,
  transportDate,
  transportTime,
  upsertForm,
  showToaster,
  onHistoryPush,
) => {
  api.getCities(addressFrom.locality, values(DEPARTMENT_CODES)).then(resp => {
    // console.log(addressFrom, addressTo, transportDateTime, resp);
    const searchCity =
      (resp?.data?.cities || []).filter(city => {
        const zone = zoneToPolygon(city);
        // console.log(zone, TURF_POLYGON);
        let inPoly = false;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < zone.length; i++) {
          if (booleanPointInPolygon(point(zone[i]), tpolygon(TURF_POLYGON))) {
            inPoly = true;
            break;
          }
        }
        return inPoly;
      }) || resp.data.cities;
    const km = distance(
      point([addressFrom.latitude, addressFrom.longitude]),
      point([addressTo.latitude, addressTo.longitude]),
      { units: 'kilometers' },
    );
    upsertForm({ addressFrom, addressTo, transportDate, transportTime, distance: km });
    if (searchCity && searchCity.length > 0) {
      onHistoryPush(searchCity[0].slug);
    } else {
      console.log(
        `City '${addressFrom.locality}' not found in polygon (${resp?.data?.cities?.length} cities tested)`,
      );
      showToaster();
    }
  });
};
